import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

document.querySelectorAll('[data-admin-menu-item]').forEach((element) => {
    tippy(element, {
        content: element.textContent.trim(),
        placement: 'right',
        onShow: () => window.innerWidth < 768,
    });
});
